import { Component } from '@angular/core';

@Component({
    selector: 'brightside-web-loan-dashboard-disclaimer',
    templateUrl: './loan-dashboard-disclaimer.component.html',
    styleUrls: ['./loan-dashboard-disclaimer.component.scss'],
    standalone: false
})
export class LoanDashboardDisclaimerComponent {}
